module.exports = __webpack_public_path__ + "img/en-EN.5a8feeb3.svg";